import Heading from "components/Heading/Heading";
import { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import VectorImg from "images/vectors/VectorHIW.svg";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useDispatch } from "react-redux";
import { setTrend } from "application/features/search/searchSlice";
import useWindowSize from "application/hooks/useWindowResize";
import { stockTypeToSlug } from "data/stock_types";
import { StockNumericType } from "data/enums";
import { useNavigate } from "react-router-dom";

export interface SectionMoodProps {
  className?: string;
  heading?: string;
  description?: string;
  data?: {
    id: number;
    title: string;
    description: string;
    actionButton?: string;
    img: string;
    imgDark?: string;
  }[];
}

const SectionMood: FC<SectionMoodProps> = ({
  heading,
  description,
  data,
  className = "",
}) => {

  const dispatch = useDispatch();
  const { width } = useWindowSize();
  const navigate = useNavigate();

  const handleNavigation = (item: any) => {
    dispatch(setTrend(item.title));
    if (width > 768) {
      navigate(`/${stockTypeToSlug(StockNumericType.STAY)}`)
    }
  }

  return (
    <div
      className={`nc-SectionMood ${className} lg:!my-[5rem]`}
      data-nc-id="SectionMood"
    >
      <Heading isCenter desc={description}>
        {heading}
      </Heading>
      <div className="mt-20 relative grid md:grid-cols-3 gap-20">
        <img
          className="hidden md:block absolute inset-x-0 top-10"
          src={VectorImg}
          alt=""
        />
        {
          data.map((item) => (
            <div
              key={item.id}
              className="relative flex flex-col items-center max-w-xs mx-auto"
            >
              <NcImage
                containerClassName="dark:hidden block mb-8 max-w-[200px] mx-auto"
                src={item.img}
              />
              <div className="text-center">
                <h3 className="text-xl font-semibold">{item.title}</h3>
                <div className="grow"></div>
                <div className="block my-5 text-neutral-500 dark:text-neutral-400 min-h-24">
                  {item.description}
                </div>
                {
                  item.actionButton && <ButtonPrimary onClick={() => handleNavigation(item)}>{item.actionButton}</ButtonPrimary>
                }
              </div>
            </div>
          ))
        }
      </div>
    </div >
  );
};

export default SectionMood;
